enum SignupStep {
  AGREE_TERMS = 1,
  SELECT_TYPE = 2,
  INPUT_INFOS = 3,
  COMPLETE = 4,
}

export const allCases = [SignupStep.SELECT_TYPE, SignupStep.INPUT_INFOS, SignupStep.COMPLETE];

export const describeAt = (step: number) => {
  switch (step) {
    case SignupStep.AGREE_TERMS:
      return '이용약관에 동의해주세요.';
    case SignupStep.SELECT_TYPE:
      return '회원 유형을 선택해주세요.';
    case SignupStep.INPUT_INFOS:
      return '핀카 비즈 센터를 통해 스마트한 일상을 시작하세요!';
    case SignupStep.COMPLETE:
      return '회원 가입이 완료되었습니다.';
    default:
      return '';
  }
};

export default SignupStep;
